import React from 'react';
import noSearchResult from '../../assets/noSearchResult.svg';
import styles from './NoSearchResultsFound.module.css';

function NoSearchResultsFound({ searchQuery }) {
    return (
        <div className={styles.noSearchResultsFoundContainer}>
            <img
                className={styles.image}
                src={noSearchResult}
                alt={'no search results'}
            />
            <p className={styles.bodyLargeText}>
                Your search -{' '}
                <span className={styles.labelLargeText}>{searchQuery}</span> -
                did not match any documents
            </p>
            <p className={styles.bodyMediumText}>
                Please make sure all words are spelled correctly or try a
                different keyword.
            </p>
        </div>
    );
}

export default NoSearchResultsFound;
